module.exports = __webpack_public_path__ + "chrome-logo-063b146cef316aba2edafae8a2e9341d.svg";